import common from '../common.vue'
import response from '../response.js'

export default {
  install(app, options) {
    app.component('common-data', common)
    app.directive('common-display', {
        bind (el, binding) {
            el.style.opacity = '0'
            response.onload(() => {
                el.style.opacity = '1'
            })

        }
    })
  }
}